import { mapGetters, mapActions } from 'vuex'
import SiteSearchGroup from '@/components/search-group'
import { co_author } from '@/api/co_author'
import Detail from './dialog/detail.dialog.vue'
import VerifyCoAuthorship from './dialog/verify-coAuthorship.dialog.vue'
import CoAuthorshipConfirm from './dialog/co-authorship-confirm.dialog.vue'
import CoAuthorshipDecline from './dialog/co-authorship-decline.dialog.vue'
import { ARTICLE_STATUS } from '@/utils/dict'
import file from '@/api/file'

const columns = [
  {
    title: '',
    enTitle: 'Manuscript No.',
    width: 200,
    dataIndex: 'code'
  },
  {
    title: '',
    enTitle: 'Article Title',
    width: 300,
    dataIndex: 'title',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Submitted Author',
    width: 200,
    dataIndex: 'submitter',
    slot: 'submitter'
  },
  {
    title: '',
    enTitle: 'Status / Date',
    width: 300,
    dataIndex: 'statusTime',
    slot: 'date'
  },
  {
    title: '',
    enTitle: 'Submission Date',
    width: 200,
    dataIndex: 'firstSubmitTime',
    slot: 'firstSubmitTime',
    sort: true
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 230,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
export default {
  components: {
    SiteSearchGroup,
    Detail,
    VerifyCoAuthorship,
    CoAuthorshipConfirm,
    CoAuthorshipDecline
  },
  data() {
    return {
      columns,

      dataSource: [],
      params: {
        keyword: '',
        sorted: ''
      },
      pagination: {
        total: 0,
        size: 50,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true
      },
      inputData: {
        coAuthor: {
          code: ''
        }
      },
      isVisableDetail: false, // 详情
      showVerify: false, // 验证
      showConfirm: false, // 确认
      showDecline: false, // 取消
      status1: ARTICLE_STATUS
    }
  },
  computed: {
    ...mapGetters({
      domain: 'getDomain',
      user: 'getUser'
    })
  },
  async mounted() {
    await this.getList()
  },
  methods: {
    ...mapActions(['updateDomain']),
    async getDomain() {
      const domain = await file.domain()
      this.updateDomain(domain)
    },
    async getList(page = 1) {
      const data = Object.assign(this.params, {
        pageIndex: page,
        pageSize: this.pagination.size
      })
      const { list, pageIndex, pageSize, total } = await co_author.getList(data)
      this.dataSource = list
      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex
      })
    },
    // 查看详情
    detail(val) {
      this.isVisableDetail = true
      this.inputData = val
    },
    // 共同作者验证
    verify(val) {
      this.showVerify = true
      this.inputData = val
    },
    cancel() {
      this.showVerify = false
      this.isVisableDetail = false
      this.showDecline = false
      this.showConfirm = false
    },
    confirm() {
      this.showVerify = false
      this.showDecline = false
      this.showConfirm = true
    },
    decline() {
      this.showVerify = false
      this.showConfirm = false
      this.showDecline = true
    },
    handleClear() {
      this.params.keyword = ''
      this.getList()
    },
    onOrderChanage(val) {
      this.params.sorted = val
      this.getList()
    },
    // 查看决策
    decision(val) {
      this.$router.push(
        `/author/co-author-manuscripts/view-decision?id=${val.id}&sign=${val.sign}`
      )
    },
    // confirm Submit to Publication
    confirmSubmit() {
      this.showConfirm = false
      this.getList()
    },
    // Decline Submit to Publication
    declineSubmit() {
      this.showDecline = false
      this.getList()
    }
  }
}
